import React from 'react'
import { mq, fontGraphik } from '../../utils'
import { RichText } from '../RichText'
import { Text } from '../Text'
import { IProps } from './index'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { FeatureGridItem as FeatureGridItemDefault } from './component'

export const FeatureGridItem = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <FeatureGridItemDefault {...props} />
  }
  return <FeatureGridItemLegacy {...props} />
}

const FeatureGridItemLegacy: React.FC<IProps> = ({ name, description, centerAlign }) => {
  return (
    <>
      <div className="feature-grid-item">
        <p className="name">{name && <RichText document={name} />}</p>
        <p className="description">
          <Text size="body">{description}</Text>
        </p>
      </div>
      <style jsx>
        {`
          .feature-grid-item {
            text-align: ${centerAlign ? 'center' : 'left'};
            margin: ${centerAlign ? '0 auto' : '0'};
          }
          .name {
            margin-bottom: 6px;
            font-weight: bold;
            font-family: ${fontGraphik};
            font-size: 16px;
          }
          @media (${mq.tablet}) {
            .name {
              margin-bottom: 8px;
            }
          }
        `}
      </style>
    </>
  )
}
